import { render, staticRenderFns } from "./InsPresident.vue?vue&type=template&id=0fa201da&scoped=true"
import script from "./InsPresident.vue?vue&type=script&lang=ts"
export * from "./InsPresident.vue?vue&type=script&lang=ts"
import style0 from "./InsPresident.vue?vue&type=style&index=0&id=0fa201da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa201da",
  null
  
)

export default component.exports